<!-- <div class="UNFAPP-fltr-fld-grp" [ngClass]="mobfilterstatus?'opened':''"> -->
  <!-- <span class="UNFAPP-fltr-mob-clsbtn" (click)="mobfilterbtnAction()"><img
          src="assets/img/filter-close-icon.png" /></span> -->
  <!-- <h3 class="UNFAPP-fltr-mobhdng">Filter by</h3> -->
  <ng-container *ngFor="let item of filterList; let i=index">
  <ng-container *ngIf="!item.multiselect && item?.values?.length > 0 && !crntRecordType ">
    <div class="fltr-drdp-bx">
      <h3 class="fltr-drdp-bx-mob-hdng">SELECT  {{item.name | titlecase}}</h3>
      <div class="fltr-drdp-slctd-sctn " [ngClass]="{'filterColor': (item.name == 'days' && this.activeFilter.days) || (item.name == 'type' && this.activeFilter.type)}">
        <ng-container *ngIf="!selectedFilters[item.key]">
          {{item.name | titlecase}}
        </ng-container>
        <ng-container *ngIf="selectedFilters[item.key]">
          {{selectedFilters[item.key] | titlecase}}
        </ng-container>
      <i class="fa fa-caret-down" aria-hidden="true"></i></div>
      <div class="fltr-drdplst-area">
          <ul class="_fltr-subjct-list fltr-days-list">
            <ng-container *ngFor="let typeFilter of item.values; index as k">
              <li>
                <label>
                    <input type="checkbox" 
                        id="filter_opt_{{item.key}}_{{typeFilter.id}}"
                        class="radio-custom"
                        name="filter_opt_{{item.key}}"
                        [value]="typeFilter.id"
                        (change)="onFilterChange($event, item, k)"
                        [checked]="typeFilter.isSelected"/>
                    <span>{{typeFilter.name | titlecase}}</span>
                </label>
              </li>
            </ng-container>
            <li *ngIf="item.name === 'subjects'">
              <div class="clear-btn-area">
                  <button class="UNFAPP-lvcls-txtbtn" (click)="clear()">CLEAR SELECTION</button>
              </div>
            </li>
          </ul>
      </div>
    </div>
  </ng-container>
    <ng-container *ngIf="!item.multiselect && item?.values?.length > 0 && crntRecordType && crntRecordType.toLowerCase() == 'upcoming'">
      <div class="fltr-drdp-bx">
        <h3 class="fltr-drdp-bx-mob-hdng">SELECT  {{item.name | titlecase}}</h3>
        <div class="fltr-drdp-slctd-sctn " [ngClass]="{'filterColor': (item.name == 'days' && this.activeFilter.days) || (item.name == 'type' && this.activeFilter.type)}">
          <ng-container *ngIf="!selectedFilters[item.key]">
            {{item.name | titlecase}}
          </ng-container>
          <ng-container *ngIf="selectedFilters[item.key]">
            {{selectedFilters[item.key] | titlecase}}
          </ng-container>
          <i class="fa fa-caret-down" aria-hidden="true"></i></div>
        <div class="fltr-drdplst-area">
          <ul class="_fltr-subjct-list fltr-days-list">
            <ng-container *ngFor="let typeFilter of item.values; index as k">
              <li>
                <label>
                  <input type="checkbox"
                         id="filter_opt_{{item.key}}_{{typeFilter.id}}"
                         class="radio-custom"
                         name="filter_opt_{{item.key}}"
                         [value]="typeFilter.id"
                         (change)="onFilterChange($event, item, k)"
                         [checked]="typeFilter.isSelected"/>
                  <span><span class="elips-text">{{typeFilter.name | titlecase}}</span></span>
                </label>
              </li>
            </ng-container>
            <li *ngIf="item.name === 'subjects'">
              <div class="clear-btn-area">
                <button class="UNFAPP-lvcls-txtbtn" (click)="clear()">CLEAR SELECTION</button>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </ng-container>
  <ng-container *ngIf="item.multiselect && item?.values?.length > 0">
    <div class="fltr-drdp-bx" >
      <h3 class="fltr-drdp-bx-mob-hdng">SELECT {{item.name | titlecase}}</h3>
      <div class="fltr-drdp-slctd-sctn filterColor" [ngClass]="{'filterColor': (item.name == 'subjects' && this.activeFilter.subjects) || (item.name == 'languages' && this.activeFilter.languages)}" >
        <ng-container *ngIf="!selectedFilters[item.key]">
          {{item.name | titlecase}}
        </ng-container>
        <ng-container *ngIf="selectedFilters[item.key]">
          {{selectedFilters[item.key] | titlecase}}
        </ng-container>
        <i class="fa fa-caret-down" aria-hidden="true"></i>
      </div>
      <div class="fltr-drdplst-area">
          <ul class="_fltr-subjct-list" [ngClass]="item.name==='subjects'?'fltr-subjct-list':''">
            <ng-container *ngFor="let subFilter of item.values; index as j">
              <li>
                <label>
                    <input type="checkbox"
                      class="custom-control-input"
                      id="filter_sub_{{subFilter.id}}"
                      [value]="subFilter.id"
                      (change)="onFilterChange($event, item, j)"
                      [checked]="subFilter.isSelected"/>
                    <span><span class="elips-text">{{subFilter.name | titlecase}}</span></span>
                </label>
              </li>
            </ng-container>
            <li *ngIf="item.name === 'subjects'">
              <div class="clear-btn-area">
                  <button class="UNFAPP-lvcls-txtbtn" (click)="clear()">CLEAR SELECTION</button>
              </div>
            </li>
          </ul>
      </div>
    </div>
  </ng-container>
  </ng-container>
  <!-- <div class="UNFAPP-fltr-mob-actnlarea">
    <button class="UNFAPP-lvcls-txtbtn">CLEAR</button>
    <button class="UNFAPP-lvcls-blubtn">APPLY</button>
  </div>
  <button class="UNFAPP-lvcls-txtbtn UNFAPP-lvcls-fltr-txtbtn" (click)="mobfilterbtnAction()">
        <span class="fltr-ylwdot"></span> FIlter 
      <img src="assets/img/filter-blue-icon.svg" /></button> -->
